import api from '@/lib/api/axios'
import type { ListParams, PaginatedResponse } from '@/lib/api/types'

export interface MyAssignment {
    id: number | null
    requestID: string | null
    objectID: string | null
    objectDescription: string | null
    objectversionsID: number | null
    scenario: number | null
    versionMetadata: string | null
    versionAnalytics: number | null
    requestDateTime: string | Date | null
    location: string | null
    teamName: string | null
    responsibleTeamId: number | null
    forecastStartTime: string | Date | null
    objectReady: number | null
    waitGo: string | null
    requestObjectCount: number
    iconFilename: string | null
}

export interface MyAssignmentStats {
    uniqueRequestCount: number
    objectCount: number
    locationCount: number
}

export const myAssignmentsApi = {
    list: (params?: ListParams & { requestID?: string; location?: string; team?: string; recoverySet?: string }) => {
        const queryParams = params ? {
            ...params,
            limit: params.perPage || params.limit || 20,
            perPage: undefined,
        } : undefined
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key as keyof typeof queryParams] === undefined) {
                    delete queryParams[key as keyof typeof queryParams]
                }
            })
        }
        return api.get<PaginatedResponse<MyAssignment>>('/api/my-assignments', { params: queryParams })
    },
    getLocationOptions: () => api.get<{ success: boolean; data: string[] }>('/api/my-assignments/filter-options/locations'),
    getTeamOptions: () => api.get<{ success: boolean; data: string[] }>('/api/my-assignments/filter-options/teams'),
    getRecoverySetOptions: () => api.get<{ success: boolean; data: string[] }>('/api/my-assignments/filter-options/recovery-sets'),
    getStats: () => api.get<{ success: boolean; data: MyAssignmentStats }>('/api/my-assignments/stats'),
}
